import React, { createContext, useContext, useEffect } from "react";

/**
 * Allows embedded AI Bank tab pages to inject actions into the parent
 * PageHeader's actions slot.
 */
export const AIBankHeaderContext = createContext({ setHeaderActions: () => {} });

/**
 * Hook for embedded children: renders `node` into the parent header while
 * mounted, and clears it on unmount or when `node` changes.
 */
export const useAIBankHeaderActions = (node, deps = []) => {
  const { setHeaderActions } = useContext(AIBankHeaderContext);
  useEffect(() => {
    setHeaderActions(node);
    return () => setHeaderActions(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
